module.exports = __webpack_public_path__ + "static/media/0.c386641a.jpg";